import { Card, CardContent } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { FilterList, FilterListItem } from 'react-admin';
import { useBillerGetFilters } from './BillerMerchantCodesFilters';

const BillerMerchantCodesAside = () => {
  const { paymentGateways } = useBillerGetFilters();
  return (
    <Card
      sx={{
        order: -1,
        flex: '0 0 15em',
        mr: 2,
        mt: 6,
        alignSelf: 'flex-start',
        height: '85vh',
        overflowY: 'auto',
      }}
    >
      <CardContent sx={{ pt: 1 }}>
        <FilterList label="Payment Gateway" icon={<CheckCircleOutlineIcon />}>
          {paymentGateways.map((paymentGateway: any) => (
            <FilterListItem
              key={paymentGateway.pgId}
              label={paymentGateway.pgName}
              value={{ paymentGatewayId: paymentGateway.pgId }}
            />
          ))}
        </FilterList>
      </CardContent>
    </Card>
  );
};

export default BillerMerchantCodesAside;
